<p-confirmPopup></p-confirmPopup>
<div class="activity-outer basic-tabs common-booking-payment crm-payment-tabs">
    <p-table id="tbl-custom" [value]="customInvoiceList" [tableStyle]="{ 'min-width': '50rem' }" [resizableColumns]="true" columnResizeMode="expand">
        <ng-template pTemplate="header">
            <tr>
                <th scope="col">Invoice Number</th>
                <th scope="col">Company</th>
                <th scope="col">Parking Lot</th>
                <th scope="col">Arrival Date & Time</th>
                <th scope="col">Departure Date & Time</th>
                <th scope="col">Time Zone</th>
                <th scope="col">Generated By</th>
                <th scope="col">Invoice Date</th>
                <th scope="col">Created Date</th>
                <th scope="col">Amount ($)</th>
                <th scope="col">Payment Mode</th>
                <th scope="col">Payment Status</th>
                <th scope="col">Actions</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
            <tr>
                <td>{{product.invoiceNumber}}</td>
                <td>{{product.company}}</td>
                <td>
                    <div class="big-parking">
                        <h5>{{product.parkingLotName}}</h5>
                        <p>{{product?.address}}</p>
                    </div>

                </td>
                <td>{{product.arrivalDate || '-'}}</td>
                <td>{{product.departureDate || '-'}}</td>
                <td>{{product?.timeZone? getTimeZoneAbbreviation(product?.timeZone): '-'}}</td>
                <td>{{product.generatedBy}}</td>
                <td>{{(product.billingDate)}}</td>
                <td>
                    {{(product.dateCreated) }}
                </td>
                <td>{{product.totalAmount}}
                </td>
                <td>{{product.bookingPaymentMode | paymentModeValue}}</td>
                <td>
                    <div class="big-parking"><p class="common-payment-status"
                      [ngClass]="product.paymentStatus | invoicePaymentStatus">{{product.status}}
                      <span *ngIf="product?.paymentFailureError && product.paymentStatus === invoicePaymentStatus.PaymentFailed"><em class="pi pi-info-circle" [pTooltip]="product?.paymentFailureError"
                        tooltipPosition="top"></em></span>
                    </p></div>
                    </td>
                <td>
                    <div class="action-item">

                        <div class="export-btn" (click)="showData(product,$event);menu.toggle($event)">

                            <img src="assets/images/dot.svg" alt="" />

</div>
                    </div>
                </td>
            </tr>

</ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
            <tr class="no-border">
                <td class="no-record" colspan="12">
                    No Record Found
                </td>
            </tr>
        </ng-template>
    </p-table>

</div>
<div class="card common-content-end custom-pagination1"  *ngIf="customInvoiceList?.length > 0">
    <p-paginator [rows]="itemsPerPage"  [totalRecords]="totalCustomInvoices"
    (onPageChange)="onPageChange($event)"></p-paginator>
</div>
<div class="custom-export"><p-menu #menu [model]="items" [popup]="true"></p-menu></div>